export default Object.freeze({
  Gender         : {
    MALE  : "USR1011001",
    FEMALE: "USR1011002",
  },
  PaymentStatus  : {
    BEFORE_PAYMENT: "PAYMSS1001",
    PAID          : "PAYMSS2001",
    FAILED        : "PAYMSS4001",
    CANCELLED     : "PAYMSS9001",
  },
  ApplicationType: {
    NEW   : "COUNST0001",
    RE_NEW: "COUNST0002"
  },
  MedicalDeptId  : {
    GYNECOLOGICALTUMOR: 1,
    INFERTILITY       : 2,
  },
  CounsProcStatus: {
    접수  : "COUNSS1001",
    예약확정: "COUNSS2001",
    완료  : "COUNSS3001",
    취소  : "COUNSS4001",
  },
  CounsWay       : {
    VIDEO: "COUNSW0001",
    TEL  : "COUNSW0002",
  },
  TrmtProcStatus : {
    접수  : "TRMTSS1001",
    예약확정: "TRMTSS2001",
    완료  : "TRMTSS3001",
    취소  : "TRMTSS4001",
  },
  TrmtCategory   : {
    일반진료: "TRMTCT1001",
    이차소견: "TRMTCT1002",
  },
  UserType       : {
    관리자   : "USR1001001",
    환자    : "USR1002001",
    의사    : "USR1003001",
    상담원   : "USR1004001",
    협력병원의사: "USR1005001",
  },
  FileCategory   : {
    상담    : "MFCATE1001",
    상담결과  : "MFCATE1002",
    진료    : "MFCATE2001",
    진료결과  : "MFCATE2002",
    이차소견  : "MFCATE3001",
    이차소견결과: "MFCATE3002",
    의료진   : "MFCATE4001",
  },
  QuestionType   : {
    CHOICE    : "QST1001001",
    SUBJECTIVE: "QST1002001"
  },
  AnswerType     : {
    ETC: 99
  },
  UserRole       : {
    PATIENT: "ROLE_PATIENT",
  },
  InquiryStatus  : {
    RECEPTION: "INQURY1001",
    COMPLETED: "INQURY2001",
  },
  MagazineType      : {
    PDF    : "MAGATY1001",
    유튜브  : "MAGATY2001",
    페이스북    : "MAGATY3001",
    직접입력    : "MAGATY4001"
  },
});
